var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgPhoto = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 13.063V13.0646V18.6809C23 20.1027 21.8474 21.2553 20.4255 21.2553H3.66976H3.66665H3.57447C2.15263 21.2553 1 20.1027 1 18.6809V5.57447C1 4.15263 2.15263 3 3.57447 3H20.4255C21.8474 3 23 4.15263 23 5.57447V13.063V13.063ZM21.5957 11.3344V5.57447C21.5957 4.92818 21.0718 4.40426 20.4255 4.40426H3.57447C2.92818 4.40426 2.40426 4.92818 2.40426 5.57447V18.6809C2.40426 19.2686 2.83749 19.7551 3.40202 19.8384L11.7984 11.8984C12.0746 11.6372 12.5085 11.6432 12.7773 11.912L14.3355 13.4702L18.5199 9.20208C18.796 8.92047 19.2498 8.92142 19.5247 9.20418L21.5957 11.3344V11.3344ZM21.5957 13.3489L19.0192 10.6987L14.8418 14.9596C14.5684 15.2385 14.1201 15.2407 13.8439 14.9646L12.2672 13.3878L5.43246 19.8511H20.4255C21.0718 19.8511 21.5957 19.3271 21.5957 18.6809V13.3489V13.3489ZM6.85106 11.1915C5.55848 11.1915 4.51064 10.1436 4.51064 8.85106C4.51064 7.55848 5.55848 6.51064 6.85106 6.51064C8.14365 6.51064 9.19149 7.55848 9.19149 8.85106C9.19149 10.1436 8.14365 11.1915 6.85106 11.1915ZM6.85106 9.78723C7.3681 9.78723 7.78723 9.3681 7.78723 8.85106C7.78723 8.33403 7.3681 7.91489 6.85106 7.91489C6.33403 7.91489 5.91489 8.33403 5.91489 8.85106C5.91489 9.3681 6.33403 9.78723 6.85106 9.78723Z",
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor'
  }));
};
export default SvgPhoto;